import React from 'react';
import { Card, CardContent, Skeleton, Box, Typography } from '@mui/material';

interface StoreTableSkeletonProps {
    title?: string;
    rows?: number;
    hasAction?: boolean;
}

const StoreTableSkeleton = ({ 
    title, 
    rows = 3,
    hasAction = true 
}: StoreTableSkeletonProps) => {
    return (
        <Card>
            <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                    {title ? (
                        <Typography variant="h6">{title}</Typography>
                    ) : (
                        <Skeleton variant="text" width={180} height={28} />
                    )}
                    {hasAction && <Skeleton variant="rectangular" width={120} height={36} sx={{ borderRadius: 1 }} />}
                </Box>
                
                <Box>
                    {Array.from({ length: rows }).map((_, index) => (
                        <Box 
                            key={index} 
                            sx={{ 
                                display: 'flex', 
                                gap: 2, 
                                alignItems: 'center',
                                py: 1.5,
                                borderBottom: index < rows - 1 ? '1px solid rgba(0, 0, 0, 0.12)' : 'none'
                            }}
                        >
                            <Skeleton variant="text" width="25%" height={20} />
                            <Skeleton variant="text" width="30%" height={20} />
                            <Skeleton variant="text" width="20%" height={20} />
                            <Box sx={{ ml: 'auto', display: 'flex', gap: 1 }}>
                                <Skeleton variant="circular" width={32} height={32} />
                                <Skeleton variant="circular" width={32} height={32} />
                            </Box>
                        </Box>
                    ))}
                </Box>
            </CardContent>
        </Card>
    );
};

export default StoreTableSkeleton;
